import { onApiError } from "../error"
import { objectToQueryString } from "../utils"
import { del, get, put } from "./client"

/**
 * @param {string} imei
 */
async function deleteFencealarm(imei) {
    const res = await del(`/fencealarms/${imei}`)
    if (!res.ok) throw await onApiError(res)
}

/**
 * @param {string} imei 
 * @returns {Promise<Fencealarm>}
 */
async function delFencealarmSubscription(imei) {
    const res = await del(`/fencealarms/${imei}/subscription`)
    if (!res.ok) throw await onApiError(res)
    return res.json()
}

/**
 * @param {string} imei
 * @returns {Promise<Fencealarm>}
 */
async function getFenceAlarm(imei) {
    const res = await get(`/fencealarms/${imei}`)

    if (res.status === 408) throw new Error('TIMEOUT')
    if (!res.ok) throw await onApiError(res)
    return await res.json()
}

/**
 * @param {string} imei
 * @param {PutFencealarmParams} args
 * @returns {Promise<Fencealarm>}
 */
async function putFencealarm(imei, args) {
    const res = await put(`/fencealarms/${imei}`, {
        body: JSON.stringify(args)
    })

    if (!res.ok) throw await onApiError(res)
    return res.json()
}

/**
 * @param {string} imei 
 * @param {string} email 
 * @returns {Promise<Fencealarm>}
 */
async function putFencealarmOwner(imei, email) {
    const res = await put(`/fencealarms/${imei}/owner`, {
        body: JSON.stringify({
            Email: email,
        })
    })
    if (!res.ok) throw await onApiError(res)
    return res.json()
}

/**
 * @param {string} imei
 * @param {number} days 
 * @returns {Promise<Fencealarm>}
 */
async function putFencealarmTrial(imei, days) {
    const res = await put(`/fencealarms/${imei}/trial`, {
        body: JSON.stringify({
            Days: days,
        })
    })

    if (!res.ok) throw await onApiError(res)
    return res.json()
}

/**
 * @typedef {Object} VoltageDataPoint
 * @property {string} Imei
 * @property {number} Voltage
 * @property {string} Timestamp
 * 
 * @param {string} imei
 * @param {DataPointQueryParams} [args]
 * @returns {Promise<Blob|VoltageDataPoint[]>}
 */
async function getFencealarmVoltage(imei, args) {
    const queryString = objectToQueryString(args)
    const res = await get(`/fencealarms/${imei}/voltage${queryString}`)
    if (!res.ok) throw await onApiError(res)
    if (!args || args.format !== "json") return res.blob()
    return res.json()
}

export {
    deleteFencealarm,
    delFencealarmSubscription,
    getFenceAlarm,
    putFencealarm,
    putFencealarmOwner,
    putFencealarmTrial,
    getFencealarmVoltage,
}